/* eslint-disable react-hooks/exhaustive-deps */
import { zodResolver } from '@hookform/resolvers/zod'
import { type ActionFunctionArgs, json, redirect } from '@remix-run/node'
import { useActionData } from '@remix-run/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { useShallow } from 'zustand/react/shallow'
import {
	SET_LANGUAGE,
	SET_INITIAL_QUESTION_TREE,
} from '#app/constants/forms.ts'
import { WizardFormContainer } from '#app/features/form/components/wizardFormContainer.tsx'
import {
	initialIpipNeoTree,
	initialStateIpipNeo,
} from '#app/features/form/forms/personalityTests/ipipNeo/initialState.ts'
import { IpipNeoForm } from '#app/features/form/forms/personalityTests/ipipNeo/ipipNeoForm.tsx'
import { getValidatedFormData } from '#app/features/form/forms/utils/getValidatedFormData.ts'
import { createGlobalJSONFormStore } from '#app/features/form/wizard/reducer/createGlobalFormStore.ts'
import { useCurrentLanguage } from '#app/hooks/use-current-language.tsx'

const zodAnySchema = z.any()
const resolver = zodResolver(zodAnySchema)

export async function action({ request }: ActionFunctionArgs) {
	const { data } = await getValidatedFormData<any>(request, resolver)

	if (data.formHasBeenCompleted) {
		return redirect('/homeNew')
	}
	const updatedData = {
		...data,
		globalState: {
			...data.globalState,
			formHasBeenCompleted: true,
		},
	}

	return json({
		data: updatedData,
	})
}

export const useGlobalIpipNeoFormStore = createGlobalJSONFormStore()

export default function BigFivePersonality() {
	const actionData = useActionData<typeof action>()
	const { t } = useTranslation([
		'intakeQuestions',
		'ratingSystem',
		'ipipNeoTest',
	])

	const currentLanguage = useCurrentLanguage()
	const dispatch = useGlobalIpipNeoFormStore(
		useShallow(state => state.dispatch),
	)
	const questionTrees = useGlobalIpipNeoFormStore(
		useShallow(state => state.questionTree),
	)
	const languageId = useGlobalIpipNeoFormStore(state => state.languageId)
	const formId = useGlobalIpipNeoFormStore(state => state.formId)
	const trees = initialIpipNeoTree(t)

	useEffect(() => {
		if (formId !== 'ipipNeo') {
			dispatch({
				type: 'SET_ENTIRE_STATE',
				payload: initialStateIpipNeo as any,
			})
		}
	}, [dispatch, formId])

	useEffect(() => {
		if (currentLanguage !== languageId || questionTrees.length === 0) {
			dispatch({ type: SET_LANGUAGE, languageId: currentLanguage })
			dispatch({ type: SET_INITIAL_QUESTION_TREE, questionTree: trees })
		}
	}, [currentLanguage, dispatch, languageId, trees])

	return (
		<WizardFormContainer isPage>
			<IpipNeoForm data={actionData} />
		</WizardFormContainer>
	)
}

export const BigFivePersonalityForm = () => {
	return (
		<div className="xl:max-w-3x mx-4 h-svh items-center justify-center gap-3 pb-10 lg:mx-auto lg:w-full lg:max-w-2xl">
			<BigFivePersonality />
		</div>
	)
}
